var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClasseA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_23294",
    "data-name": "Raggruppa 23294",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94.032,
    height: 16,
    viewBox: "0 0 94.032 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_13103",
    "data-name": "Rettangolo 13103",
    width: 94.032,
    height: 16,
    rx: 3,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23293",
    "data-name": "Raggruppa 23293",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33453",
    "data-name": "Tracciato 33453",
    d: "M90.669,6.995,85.326.567A1.572,1.572,0,0,0,84.117,0H.676A.677.677,0,0,0,0,.677V15.324A.676.676,0,0,0,.676,16H84.117a1.572,1.572,0,0,0,1.209-.567l5.343-6.428a1.573,1.573,0,0,0,0-2.01",
    fill: "#e5e5e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasseA);
export default __webpack_public_path__ + "static/media/classeA.b52bc9fb67ebef93e96be81518fe2a94.svg";
export { ForwardRef as ReactComponent };